// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"6dd61163","198":"c82ce72a","498":"6addbe94","554":"28347f63","703":"f2c60403"}[chunkId] + ".chunk.js";
};